import React from 'react';
import { processSteps } from '../mock';

export const ProcessSection = () => {
  return (
    <section id="process" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            Simple 3-Step Registration Process
          </h2>
          <p className="text-lg text-[#8D6E63] max-w-3xl mx-auto">
            We've streamlined trademark registration into three comprehensive phases, handling all the complexity so you can focus on building your business.
          </p>
        </div>

        <div className="relative">
          {/* Timeline line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-1 bg-[#D7CCC8] -translate-x-1/2"></div>

          <div className="space-y-12">
            {processSteps.map((step, index) => (
              <div
                key={step.step}
                className={`flex flex-col lg:flex-row gap-8 items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                  <div className="bg-white border-2 border-[#D7CCC8] rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:border-[#8D6E63]">
                    <h3 className="text-2xl font-bold text-[#3E2723] mb-4">
                      {step.title}
                    </h3>
                    <p className="text-[#8D6E63] leading-relaxed text-base">
                      {step.description}
                    </p>
                  </div>
                </div>

                <div className="relative z-10 flex-shrink-0">
                  <div className="w-20 h-20 bg-[#3E2723] rounded-full flex items-center justify-center shadow-lg border-4 border-white">
                    <span className="text-3xl font-bold text-white">{step.step}</span>
                  </div>
                </div>

                <div className="flex-1 hidden lg:block"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-[#EFEBE9] border-2 border-[#D7CCC8] rounded-lg p-8">
          <h3 className="text-2xl font-bold text-[#3E2723] mb-4 text-center">
            Average Timeline: 8-12 Months for Complete Registration
          </h3>
          <p className="text-[#8D6E63] leading-relaxed max-w-4xl mx-auto mb-4">
            While the USPTO examination process typically takes 8-12 months from filing to final registration, this timeline can vary based on several factors including the complexity of your mark, the class of goods or services, and whether any office actions are issued. Applications with straightforward marks and proper documentation often proceed more quickly, while those requiring office action responses or encountering opposition may take longer.
          </p>
          <p className="text-[#8D6E63] leading-relaxed max-w-4xl mx-auto">
            Throughout this entire period, we actively monitor your application, provide regular status updates, and handle all communications with the USPTO on your behalf. You'll never be left wondering about the status of your application—we keep you informed every step of the way and promptly notify you of any developments requiring attention or action. Our proactive approach ensures the smoothest possible path to registration while minimizing delays and complications.
          </p>
        </div>
      </div>
    </section>
  );
};
